import React from "react";
import { BriefcaseIcon, GlobeIcon, GraduationCapIcon, PenLineIcon, BoxIcon } from "lucide-react";
import { philosophyIntro, philosophyPillars } from "../../data/aboutPage";
const icons: Record<(typeof philosophyPillars)[number]['id'], BoxIcon> = {
  language: PenLineIcon,
  career: BriefcaseIcon,
  academic: GraduationCapIcon,
  global: GlobeIcon
};
export function PhilosophyGrid() {
  return <section aria-labelledby="philosophy-title" className="w-full bg-white" data-id="element-56" data-mp="agxqms3i6417">
      <div className="mx-auto grid max-w-content gap-10 px-5 py-16 md:px-8 md:py-24 lg:grid-cols-12 lg:items-center lg:gap-16" data-id="element-57" data-mp="ehztdiwmoy7x">
        <div className="lg:col-span-5" data-id="element-58" data-mp="j8g4uxgw29rn">
          <h2 id="philosophy-title" data-id="element-59" data-mp="j9hse1f3coq9">
            <span className="block type-h2-light text-ink" data-id="element-60" data-mp="o7jderw2uy4d">Our Educational</span>
            <span className="block type-h2 text-brand" data-id="element-61" data-mp="o9ncmwj178yb">Philosophy</span>
          </h2>
          <p className="mt-6 type-body text-ink" data-id="element-62" data-mp="t4syjvcfonme">{philosophyIntro}</p>
        </div>
        <ul className="grid gap-4 sm:grid-cols-2 lg:col-span-7" data-id="element-63" data-mp="y6i8t8ru0x9f">
          {philosophyPillars.map(pillar => {
          const Icon = icons[pillar.id];
          return <li key={pillar.id} className="flex flex-col rounded-[24px] bg-mist p-6 md:p-7" data-id="element-64" data-mp="2i2z0c8cmj1oe">
                <Icon className="h-7 w-7 text-brand" aria-hidden="true" data-id="element-65" data-mp="2d3vtcid32lds" />
                <h3 className="mt-5 type-card-title text-brand" data-id="element-66" data-mp="2d68j3hp3201e">{pillar.title}</h3>
                <p className="mt-2 type-card-desc text-ink" data-id="element-67" data-mp="294wtvda4fgtq">{pillar.text}</p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}